import { LocaleString } from '@/api-client/models/utilization/Contracts'
import { ChartComponent } from '..'

export function createErrorText(text: LocaleString, locale: string): ChartComponent<'text'>[] {
  return [
    {
      type: 'text',
      text: text[locale]!,
      x: 0.5,
      y: 0.5,
      font: {
        size: 20
      },
      xLimits: [0, 1],
      yLimits: [0, 1],
      fill: '#7a7a7a'
    }
  ]
}
